/** Aktivitetslogg-panelen döljs tills funktionen används. Sätt till true för att visa. */
export const SHOW_ACTIVITY_LOG = false;
